import React, { useEffect, useState } from 'react'

interface EliminationPopupProps {
  handLabel: string
  street: string
  onDismiss: () => void
}

export function EliminationPopup({ handLabel, street, onDismiss }: EliminationPopupProps) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      onDismiss()
    }, 2500)

    const handleInput = () => {
      setVisible(false)
      onDismiss()
    }

    window.addEventListener('keydown', handleInput, { once: true })
    window.addEventListener('click', handleInput, { once: true })

    return () => {
      clearTimeout(timer)
      window.removeEventListener('keydown', handleInput)
      window.removeEventListener('click', handleInput)
    }
  }, [onDismiss])

  if (!visible) return null

  return (
    <div
      className="
        absolute bottom-4 left-1/2 -translate-x-1/2 z-50
        bg-red-900 border border-red-700 rounded-lg
        px-4 py-2 text-sm text-red-100 shadow-xl
        pointer-events-none
        animate-in fade-in duration-150
      "
    >
      <strong>{handLabel}</strong> was eliminated on the {street}. It cannot be added back.
    </div>
  )
}
